import React from 'react';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';

const FilterPanel = ({ 
  dateRange, 
  setDateRange, 
  selectedLocation, 
  setSelectedLocation,
  permitType,
  setPermitType,
  onExport 
}) => {
  const dateRangeOptions = [
    { value: 'last7days', label: 'Last 7 Days' },
    { value: 'last30days', label: 'Last 30 Days' },
    { value: 'last90days', label: 'Last 90 Days' },
    { value: 'last6months', label: 'Last 6 Months' },
    { value: 'lastyear', label: 'Last Year' },
    { value: 'custom', label: 'Custom Range' }
  ];

  const locationOptions = [
    { value: 'all', label: 'All Locations' },
    { value: 'plant-1', label: 'Plant 1 - Main Facility' },
    { value: 'plant-2', label: 'Plant 2 - North Wing' },
    { value: 'plant-3', label: 'Plant 3 - South Wing' },
    { value: 'warehouse-1', label: 'Warehouse 1' }
  ];

  const permitTypeOptions = [
    { value: 'all', label: 'All Permit Types' },
    { value: 'hot-work', label: 'Hot Work' },
    { value: 'confined-space', label: 'Confined Space' },
    { value: 'electrical', label: 'Electrical Work' },
    { value: 'height-work', label: 'Work at Height' },
    { value: 'excavation', label: 'Excavation' }
  ];

  return (
    <div className="bg-card rounded-lg border border-border p-6 shadow-card">
      <div className="flex flex-col lg:flex-row gap-4 items-end">
        <div className="flex-1 w-full lg:w-auto">
          <Select
            label="Date Range"
            options={dateRangeOptions}
            value={dateRange}
            onChange={setDateRange}
          />
        </div>
        <div className="flex-1 w-full lg:w-auto">
          <Select
            label="Location"
            options={locationOptions}
            value={selectedLocation}
            onChange={setSelectedLocation}
          />
        </div>
        <div className="flex-1 w-full lg:w-auto">
          <Select
            label="Permit Type"
            options={permitTypeOptions}
            value={permitType}
            onChange={setPermitType}
          />
        </div>
        <div className="flex gap-2">
          <Button variant="outline" iconName="Download" onClick={() => onExport('pdf')}>
            Export PDF
          </Button>
          <Button variant="outline" iconName="FileSpreadsheet" onClick={() => onExport('excel')}>
            Export Excel
          </Button>
        </div>
      </div>
    </div>
  );
};

export default FilterPanel;